import * as React from "react";
import { connect } from "react-redux";
import { Container, Loader, Button, Grid } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { toast } from "@teamprevent/common/toasts";

import { ApplicationState } from "../../applicationState";
import { importTypes } from "../model";
import ImportToolApi from "../ImportToolApi";

import FileImport from "./FileImport";

import "../styles/import-tool.scss";

interface StateProps {
    isLoading: boolean;
}

export const ImportToolUnconnected: React.FunctionComponent<StateProps> = (props: StateProps) => {
    const [importing, setImporting] = React.useState(false);
    const [type, setType] = React.useState<string>();
    const [file, setFile] = React.useState<File>();

    const changeType = React.useCallback((value: string) => {
        if (type !== value) {
            setFile(undefined);
        }

        setType(value);
    }, [type]);

    const changeFile = React.useCallback((changedFile: File) => {
        setFile(changedFile);
    }, []);

    const onImport = React.useCallback(async () => {
        setImporting(true);

        try {
            await ImportToolApi.importData(type, file);
        }
        catch {
            toast.error("Import failed");
        }
        finally {
            setFile(undefined);
            setImporting(false);
        }
    }, [file, type]);

    return (
        props.isLoading
            ? (<Loader active />)
            : (<Container textAlign="center">
                <h2>Import Tool</h2>
                <Grid>
                    <Grid.Row>
                        <Input.Dropdown
                            label="Type"
                            options={importTypes}
                            value={type}
                            onChange={changeType}
                        />
                    </Grid.Row>
                    {type && (
                        <>
                            <Grid.Row>
                                <FileImport
                                    fileName={file ? file.name : ""}
                                    onFileChange={changeFile}
                                    acceptExtensions={["txt", "csv"]}
                                />
                            </Grid.Row>
                            {file && (
                                <>
                                    <Grid.Row>
                                        <h2>
                                            {file.name}
                                        </h2>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Button onClick={onImport} disabled={importing}>Import</Button>
                                    </Grid.Row>
                                </>
                            )}
                        </>
                    )}
                </Grid>
            </Container>)
    );
};

const mapStateToProps = (state: ApplicationState): StateProps => {
    let isLoading = true;
    if (state.currentUser) {
        isLoading = false;
    }

    return {
        isLoading
    };
};

export const ImportTool = connect(mapStateToProps, null)(ImportToolUnconnected);
